import { AtTextFieldProps } from '../at-text-field'
import { FieldWrapper } from '../at-text-field/shared/field-wrapper'
import { baseFieldClasses } from '../at-text-field/shared/classes'

export type AtTextAreaProps = Omit<AtTextFieldProps, 'clear' | 'icon'> & { className?: string }

export const AtTextArea = ({
  errorText,
  hasError,
  helperText,
  label,
  name,
  onChange,
  placeholder,
  value = '',
  hideLimitHint,
  className = 'h-[6.5rem]',
  ...validation
}: AtTextAreaProps) => {
  const id = `${name}-field`

  return (
    <FieldWrapper
      characterLimit={validation.maxLength}
      label={label}
      errorText={errorText}
      hasError={hasError}
      hideLimitHint={hideLimitHint}
      helperText={helperText}
      htmlFor={id}
      length={value?.length}
      required={validation.required}
    >
      <textarea
        suppressHydrationWarning={true}
        id={id}
        value={value}
        name={name}
        className={`${baseFieldClasses(hasError)} ${className} p-4 resize-none`}
        onChange={({ currentTarget: { value } }) => onChange?.(value)}
        placeholder={placeholder}
        {...validation}
      />
    </FieldWrapper>
  )
}
